import { fireStore } from '../../firebase'
export default ({
  state: {
    loading: false,
    error: null,
    customers: [],
    customersRef: null,
    devices: [],
    devicesRef: null,
    deviceTypes: [],
    deviceTypesRef: null,
    productTypes: [],
    productTypesRef: null,
    SIMS: [],
    SIMSRef: null,
    invoices: [],
    invoicesRef: null,
    suppliers: [],
    roles: [],
    vehicles: [],
    vehiclesRef: null
  },
  mutations: {
    setLoading (state, payload) {
      state.loading = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    clearError (state) {
      state.error = null
    },
    setProductTypes (state, payload) {
      state.productTypes = payload
    },
    setProductTypesRef (state, payload) {
      state.productTypesRef = payload
    },
    setCustomers (state, payload) {
      state.customers = payload
    },
    setCustomersRef (state, payload) {
      state.customersRef = payload
    },
    setDevices (state, payload) {
      state.devices = payload
    },
    setDevicesRef (state, payload) {
      state.devicesRef = payload
    },
    setDeviceTypes (state, payload) {
      state.deviceTypes = payload
    },
    setDeviceTypesRef (state, payload) {
      state.deviceTypesRef = payload
    },
    setSIMS (state, payload) {
      state.SIMS = payload
    },
    setSIMSRef (state, payload) {
      state.SIMSRef = payload
    },
    setInvoices (state, payload) {
      state.invoices = payload
    },
    setInvoicesRef (state, payload) {
      state.invoicesRef = payload
    },
    setSuppliers (state, payload) {
      state.suppliers = payload
    },
    setRoles (state, payload) {
      state.roles = payload
    },
    setVehicles (state, payload) {
      state.vehicles = payload
    },
    setVehiclesRef (state, payload) {
      state.vehiclesRef = payload
    }
  },
  actions: {
    clearError ({ commit }) {
      commit('clearError')
    },
    fetchCustomers ({ state, commit }) {
      if (!state.customersRef) {
        commit('setCustomersRef', true)
        fireStore.collection('Customers').orderBy('customerName').onSnapshot(
          snap => {
            let customers = []
            snap.forEach(doc => {
              customers.push({
                key: doc.id,
                name: doc.data().customerName,
                shortName: doc.data().shortName,
                BDM: doc.data().BDM || null,
                BDMEmail: doc.data().BDMEmail || null,
                deskManager: doc.data().deskManager || null
              })
            })
            commit('setCustomers', customers)
          })
      }
    },
    fetchDevices ({ state, commit }) {
      if (!state.devicesRef) {
        commit('setDevicesRef', true)
        fireStore.collection('Devices').onSnapshot(
          snap => {
            let devices = []
            snap.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              devices.push(data)
            })
            commit('setDevices', devices)
          })
      }
    },
    fetchDeviceTypes ({ state, commit }) {
      if (!state.deviceTypesRef) {
        commit('setDeviceTypesRef', true)
        fireStore.collection('deviceType').orderBy('Index').onSnapshot(
          snap => {
            let deviceTypes = []
            snap.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              deviceTypes.push(data)
            })
            commit('setDeviceTypes', deviceTypes)
          })
      }
    },
    fetchProductTypes ({ state, commit }) {
      if (!state.productTypesRef) {
        commit('setProductTypesRef', true)
        fireStore.collection('productType').orderBy('Index').onSnapshot(
          snap => {
            let productTypes = []
            snap.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              productTypes.push(data)
            })
            commit('setProductTypes', productTypes)
          })
      }
    },
    fetchVehicles ({ state, commit }) {
      if (!state.vehiclesRef) {
        commit('setVehiclesRef', true)
        fireStore.collection('Vehicles').onSnapshot(
          snap => {
            let vehicles = []
            snap.forEach(doc => {
              let data = doc.data()
              if (!data.VehicleReg) {
                data.VehicleReg = data.friendlyId
              }
              vehicles.push({ ...data, key: doc.id })
            })
            vehicles.sort(function (a, b) {
              const aName = a.VehicleReg
              const bName = b.VehicleReg
              return aName < bName ? -1 : aName > bName ? 1 : 0
            })
            commit('setVehicles', vehicles)
          })
      }
    },
    fetchSIMS ({ state, commit }) {
      if (!state.SIMSRef) {
        commit('setSIMSRef', true)
        fireStore.collection('SIMS').onSnapshot(
          snap => {
            let SIMS = []
            snap.forEach(doc => {
              let data = doc.data()
              SIMS.push(data)
            })
            commit('setSIMS', SIMS)
          })
      }
    },
    fetchInvoices ({ state, commit }) {
      if (!state.invoicesRef) {
        commit('setInvoicesRef', true)
        if (this.state.user.userData.Role === 'Supplier') {
          fireStore.collection('Invoices').where('supplier', '==', this.state.user.userData.Company).onSnapshot(
          snap => {
            console.log('here')
            let invoices = []
            snap.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              invoices.push(data)
            })
            commit('setInvoices', invoices)
          })
        } else {
          fireStore.collection('Invoices').onSnapshot(
          snap => {
            let invoices = []
            snap.forEach(doc => {
              let data = doc.data()
              data.id = doc.id
              invoices.push(data)
            })
            commit('setInvoices', invoices)
          })
        }
      }
    },
    fetchSuppliers ({ commit }) {
      fireStore.collection('Suppliers').orderBy('Name')
      .get()
      .then(snap => {
        let suppliers = []
        snap.forEach(doc => {
          suppliers.push({key: doc.id, name: doc.data().Name})
        })
        commit('setSuppliers', suppliers)
      })
    },
    fetchRoles ({ commit }) {
      let roles = []
      fireStore.collection('Roles')
        .get()
        .then(snap => {
          snap.forEach(doc => {
            roles.push(doc.id)
          })
          commit('setRoles', roles)
        })
    }
  },
  getters: {
    loading (state) {
      return state.loading
    },
    error (state) {
      return state.error
    },
    customers (state) {
      return state.customers
    },
    devices (state) {
      return state.devices
    },
    deviceTypes (state) {
      return state.deviceTypes
    },
    productTypes (state) {
      return state.productTypes
    },
    SIMS (state) {
      return state.SIMS
    },
    invoices (state) {
      return state.invoices
    },
    suppliers (state) {
      return state.suppliers
    },
    roles (state) {
      return state.roles
    },
    vehicles (state) {
      return state.vehicles
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/shared/index.js